import React, { Component } from 'react'

import { Container, Row, Col, Image } from 'react-bootstrap'

import styles from './../blocks.module.sass'

export default class Main extends Component {

  render() {
    return (
      <div className={styles.aboutng}>
        <Container>
          <Row>
            <Col lg={6}>
              <div className={styles.aboutng_images + ` d-none d-lg-block`}>
                <Image alt="BRUNO ALTRO 1" className={styles.aboutng_images_1} src="./files/images/aboutng1.png" width={516} height={561} />
                <Image alt="BRUNO ALTRO 2" className={styles.aboutng_images_2} src="./files/images/aboutng2.png" width={302} height={497} />
                <Image alt="BRUNO ALTRO 3" className={styles.aboutng_images_3} src="./files/images/aboutng3.png" width={241} height={358} />
              </div>
            </Col>
            <Col lg={6}>
              <div className={styles.aboutng_toptext}>Наши ценности</div>
              <div className='d-flex align-items-end justify-content-between'>
                <div className={styles.aboutng_about_title}>
                  Инновации.<br />
                  Креатив. Стиль.
                </div>
                <div className='d-lg-none'> </div>
              </div>
              <div className={styles.aboutng_text}>
                <p><b>BRUNO ALTRO</b> – это бренд, рожденный в Москве, вобрал в себя лучшие черты итальянской элегантности и французского шика, при этом сохранив индивидуальность и неповторимый характер. Вдохновленные такими мастерами стиля, как Loro Piana, Brunello Cucinelli, Tom Ford и Stefano Ricci, дизайнеры BRUNO ALTRO создают одежду, которая отвечает самым высоким стандартам качества и при этом остается доступной.</p>
                <p>Создатели <b>BRUNO ALTRO</b> – настоящие эксперты в мире моды, более 15 лет проработавшие с легендарными брендами в знаменитом ЦУМе. Их глубокое знание индустрии и тонкое чувство стиля позволяют создавать одежду, которая выделяются на фоне остальных, предлагая своим клиентам возможность быть неповторимы.</p>
                <p>Отдельного внимания заслуживает <b>услуга индивидуального пошива</b>, благодаря которой вы можете получить вещь, идеально сидящую по фигуре и отвечающую всем вашим пожеланиям. Эксклюзивность – еще одна важная черта бренда. Каждая модель выпускается ограниченным тиражом, что делает ее еще более привлекательной для тех, кто ценит уникальность.</p>
              </div>
              <div className={styles.aboutng_text2}>
                <p><b>BRUNO ALTRO</b> – это не просто одежда, это философия, это образ жизни, это возможность выразить себя через стиль.</p>
              </div>
              <div className={styles.aboutng_mobimages + ` d-flex w-100 justify-content-center d-lg-none`}>
                <Image alt="BRUNO ALTRO 4" src="./files/images/aboutng_image_mob.png" width="355" height="410" />
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    )
  }
}